import React, { useEffect, useState } from "react";
import ThemeLoader from "../../layout/Loader/ThemeLoader";
import { Helmet } from "react-helmet";
import { useParams, useSearchParams } from "react-router-dom";
import { AXIOS_RESERVATION } from "../../util/axiosInterceptors";

function LinkBooking() {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (document) {
      document.querySelector("header").style.display = "none";
    }
  }, [document]);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const res = await AXIOS_RESERVATION.post(
          `/v1/coupons/redeem/link-booking/${params.stayId}`,
          {
            reservationId: searchParams.get("reservationId"),
            hotelCode: searchParams.get("hotelCode"),
          }
        );
        setLoading(false);

        const bookingUrl = res.data?.result?.data?.bookingUrl;
        if (bookingUrl) {
          window.location.href = bookingUrl;
        }
      } catch (error) {
        console.log({ error });
        setError(error?.response?.data?.result?.message);
        setLoading(false);
      }
    })();
  }, []);

  return (
    <section className="overflow-hidden">
      <Helmet>
        <title>Link Booking</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
      </Helmet>
      <div className="fixed top-0 w-screen h-screen flex items-center justify-center bg-surface z-50">
        {error ? (
          <h1>{error}</h1>
        ) : loading ? (
          <ThemeLoader className="w-24 md:w-28 lg:w-32" />
        ) : null}
      </div>
    </section>
  );
}

export default LinkBooking;
